import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { COLUMN_CODE, TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../managers/TableManger";
import { fetchFilteredPayrolls, fetchPayrolls, fetchPayschedules, fetchUsers, fetchWorkWeeks, selectPayroll, selectPayrollColumnConfig, selectPaySchedule, selectUsers, selectWorkweeks } from "../../Redux/Slices/PayrollSlice";
import Utility from "../../utility/Utility";
import { parseColumnConfig, PayrollColumnConfig } from "../configs/config";
import { showLoader,DKIcons,DKLabel, removeLoader, showAlert, showToast, TOAST_TYPE } from 'deskera-ui-library';
import Popup from "../common/Popup";
import { deepClone } from "../../utility/Utility"
import PayrollService from "../../services/PayrollService";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import Table from "../../services/table";
import SegmentListContainer from "../list/SegmentListContainer";
import { DKButton } from "deskera-ui-library";
import { POPUP_CLICK_TYPE } from "../../constants/Enums";
import { showPayrollPopup } from "../../SharedComponents/AddPayrollPopUp";
import { PayrollManager } from "../../managers/PayrollManager";
import { fetchTenantData, selectTenanatData } from "../../Redux/Slices/EmployeeListSlice";
import ReadWatchComponent from "../common/ReadWatchComponent";
import AppManager from "../../managers/AppManager";
import TenantManager from "../../managers/TenantManager";
import { getExportDataFile } from "../import_export/utility/ExportData";
import { supportedFileTypes } from "../import_export/EximConstants";
import FormatCurrency from "../../SharedComponents/FormatCurrency";
import { FORMAT, INPUT_TYPE } from "../../constants/Constant";
import { fetchLocationDimentionList, fetchLocationList, selectLocationDimentionList, selectLocationList } from "../../Redux/Slices/LocationListSlice";
import GiroService from "../../services/GiroService";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import { LOCATION_COLUMN_CONFIG } from "../add-employee/steps/Employee";
import { fetchCustomFields, selectCustomField } from "../../Redux/Slices/CustomFieldsSlice";
import CustomFieldService from "../../services/CustomFieldService";
import { saveAs } from 'file-saver';
import moment from "moment";
import { convertDateToJson } from "../../managers/common/CommonUtil";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

const PayrollGrid = (props) => {
    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: []
    };

    const initialPayrollFilters = [
        { id: 0, name: 'All' },
        { id: 1, name: 'Upcoming' },
        { id: 2, name: 'Previous' },
    ]

    //State hooks
    const [refresh, setRefresh] = useState(false);
    const [payrolls, setPayrolls] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(10);
    const [payrollFilters, setPayrollFilters] = useState(initialPayrollFilters);
    const [showList, setFiltersList] = useState(true);
    const [initialValue, setFilterInitialValue] = useState(0);
    const [recentUpcoming, setRecentUpcoming] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [latestProcessedPayrollId,setLatestProcessedPayrollId]=useState([]);
    const isActionEnabled = true;
    const [reload, setReload] = useState(false);
    const [tenantDetails, setTenantDetails] = useState(TenantManager.getTenantDetails);
    const [conditionFilter, setConditionFilter] = useState([]);
    const [filterArray, setFilterArray] = useState([]);

    var selectedRow = []
    const [exportButtonName, setExportButtonName] = useState('Export Payrun')
    const [applicableToPopup, setApplicableToPopup] = useState(null)

    //Store data selectors
    const dispatch = useDispatch();
    const payrollData = useSelector(selectPayroll);
    const columnConfig = useSelector(selectPayrollColumnConfig);
    const workWeek = useSelector(selectWorkweeks);
    const payscheduleList = useSelector(selectPaySchedule);
    const tenantData = useSelector(selectTenanatData);
    const users = useSelector(selectUsers);
    const locationData = useSelector(selectLocationList);
    const customFieldsData = useSelector(selectCustomField);
    const [isFilterEnabled, setIsFilterEnabled] = useState(false);

    const popupBtnConfig = [
        {
            title: 'Update',
            class: 'bg-app text-white mr-s',
            clickAction: POPUP_CLICK_TYPE.UPDATE_CONTACT
        },
        {
            title: 'Cancel',
            class: 'border-m mr-ss',
            clickAction: POPUP_CLICK_TYPE.CLOSE_POPUP
        }
    ];

    const deleteConfirm = (data) => [
        {
            title: "Cancel",
            className: "bg-gray1 border-m",
            onClick:()=>loadPayrolls(PayrollService.config)
        },
        {
            title: "Delete",
            className: "bg-red text-white ml-r",
            onClick: () => deleteRecord(data),
        },
    ];

    const cannotDeleteOrUpdate =[
        {
            title: "Cancel",
            className: "bg-gray1 border-m",
        }
    ];

    useEffect(() => {
        RouteManager.setPresenter({ props });
        if(!Utility.isEmpty(users) || users.length === 0) {
          loadUsersList({})
        }
        showLoader();
        /* API Calls Start */
        loadPayrolls({});
        const tenantDetails = TenantManager.getTenantDetails()
        const additionalSettings = tenantDetails
        ? tenantDetails.additionalSettings
        : "";

        const locationSettings = additionalSettings ? additionalSettings?.['LOCATION'] : {};
        const trackLocation = locationSettings?.trackLocation || false;
        
        if(trackLocation) {
          loadLocationList()
        }
        loadTenantData({});
        loadCustomFields({});
        window.viewApplicableTo=(data)=>{
          setApplicableToPopup(Utility.decodeJSON(data))
        }
        /* API Calls End */
        return () => {
            if(PayrollService.filterArray) {
                PayrollService.filterArray = null;
            }
            setPayrolls(initialState);
            window.viewApplicableTo = null;
          }
    }, [])

    useEffect(() => {
        if (!Utility.isEmpty(payrollData)) {
            const filterResponse = payrollData.filterResponse;
            const payruns = payrollData.payruns || [];
            const { tenant } = TenantManager.getPeopleTenantData();
            const { customFields } = customFieldsData;
            const isCashfreeEnabled = tenant && tenant.isCashfreeEnabled ? tenant.isCashfreeEnabled : false;
            const functionConfig = getFunctionConfig();
            let recent = getRecentUpcomingPayroll(payruns);
            let proceesPayrolls = getProcessedPayroll(payruns)
            const rowData = PayrollColumnConfig(
              payruns,
              isCashfreeEnabled,
              functionConfig,
              proceesPayrolls,
              tenantDetails,
              customFields,
              MODULE.PAYRUN
            );
            
            let { isLocationActive } = getLocationActiveStatus();
            let payrollColumn = parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PAYROLL), TABLES.PAYROLL);
            payrollColumn = isLocationActive ? updateEmployeeColumnConfig(payrollColumn) : payrollColumn;
            payrollColumn = updateColumnConfigWithCustomField(payrollColumn);

            
            getLatestProcessedPayroll(payruns)
            const passingData = {
                columnData: deepClone(payrollColumn),
                rowData,
                filter: [],
                originalData: payruns
            };
            const isFilterListEnabled = payrollData.length > 0 ? true : false;
            removeLoader();
            setIsFilterEnabled(isLocationActive || customFields?.length > 0);
            setPayrolls(passingData);
            setTotalPageCount(filterResponse.totalPages);
            setCurrentPage(+filterResponse?.currentPage);
            setTotalCount(filterResponse.totalCount)
            setFiltersList(isFilterListEnabled);
            setFilterInitialValue(initialValue);

            const loadWorkWeeks = loadWorkWeeksList();
            const loadPayschedules = loadPayscheduleList();

        }
    }, [payrollData, locationData, reload]);

    const getLatestProcessedPayroll=(payrunData)=> {
      let latestData = []
      let inputPayrolls = payrunData.filter(x=> x.processed);
      const sortByDate = arr => {
          const sorter = (a, b) => {
              return new Date(b.processedAt).getTime() - new Date(a.processedAt).getTime();
          }
          arr.sort(sorter)
      }
      sortByDate(inputPayrolls);
      if(inputPayrolls.length > 0) {
          let processedPayrollId = inputPayrolls[0]._id;
          latestData.push(processedPayrollId);
      }
      setLatestProcessedPayrollId(latestData)
  }
    const loadWorkWeeksList = async(config) => {
        try {
            // PayrollService.apiConfig = config;
            await dispatch(fetchWorkWeeks());
        } catch( err) {
            console.error('Error loading workweeks: ', err);
        }
    }

    const loadPayscheduleList = async (config) => {
        try {
            config = {
                // SearchTerm?: string;
                Limit:1000,
                CurrentPage: 1,
                Order: 'desc',
                Field: "_id"
                // IncludeOweAmounts?: boolean;
                // IncludeOpeningAmounts?: boolean;
            }
            PayrollService.apiPayScheduleConfig = config;
            await dispatch(fetchPayschedules());
        } catch (err) {
            console.error('Error loading workweeks: ', err);
        }
    }

    const loadUsersList = async (config) => {
        try {
            // PayrollService.apiConfig = config;
            await dispatch(fetchUsers());
        } catch (err) {
            console.error('Error loading workweeks: ', err);
        }
    }

    const loadPayrolls = async (config) => {
        try {
            PayrollService.apiConfig = config;
            if(PayrollService.filterArray?.length > 0) {
                await dispatch(fetchFilteredPayrolls())
            } else {
                await dispatch(fetchPayrolls());
            }
        } catch (err) {
            console.error('Error loading payrolls: ', err);
        }
    };

    const loadTenantData = async (config) => {
      try {
        await dispatch(fetchTenantData());
      } catch (err) {
        console.error("Error loading tenant data: ", err);
      }
    };

    const loadLocationDimenionData = async () => {
      try {
        await dispatch(fetchLocationDimentionList());
      } catch (err) {
        console.error("Error loading dimension data: ", err);
      }
    };
    const loadLocationList = async () => {
      try {
        await dispatch(fetchLocationList());
      } catch (err) {
        console.error("Error loading location data: ", err);
      }
    };
    const loadCustomFields = async (config) => {
        try {
          config = {
            ...CustomFieldService.apiConfig,
            Module: "payrun",
          };
          CustomFieldService.apiConfig = config;
          await dispatch(fetchCustomFields());
        } catch (err) {
          console.error("Error loading custom fields data: ", err);
        }
      };

    const onDeletePayroll = (data) => {
        const rowData = data && data.rowData ? data.rowData : '';
        if(rowData && typeof data == 'object') {
            if(!rowData.processed || rowData.allowToRevertDelete) {
                showAlert(
                    "Delete Record?",
                    "Deleting this record will delete it permanently you will not be able to restore it.",
                    deleteConfirm([rowData])
                )
            } else {

            }
        } else {
          let isProcessed = false;
          data.forEach(row=>{
            if(row.processed && !row.allowToRevertDelete){
              isProcessed = true;
            }
          })
          if(isProcessed) {
              showAlert(
                  "Sorry!!",
                  "The payrun cannot be deleted as the permissible date for deleting has passed",
                  cannotDeleteOrUpdate
              )
              loadPayrolls(PayrollService.config)
              return;
          } else {
            showAlert(
              "Delete Record?",
              "Deleting this record will delete it permanently you will not be able to restore it.",
              deleteConfirm(data)
          )
          }

        }
        // ContactService.deleteContact(payrollId).then((res) => {
        //     showToast('Contact Deleted Successfully', TOAST_TYPE.WARNING);
        //     loadContacts({});
        // });
    };

    const deleteRecord = (data) => {

        let params = []
        data.forEach(row=>{
          params.push({
            payrunId:row.id
          })
        })

        Table.deletePayroll(params).then((data) => {
            showToast("Record Deleted Successfully", TOAST_TYPE.SUCCESS);
            loadPayrolls(PayrollService.config)
        })
    }

    const viewDetailedView = (data) => {
        const rowData = data && data.rowData ? data.rowData : "";
        if (rowData) {
          if (rowData.processed) {
            let payrunId = rowData.id;
            if(payrunId) {
                RouteManager.navigateToPage(
                  PAGE_ROUTES.PROCESS_SUMMARY,
                  `id=${payrunId}&isContractor=false`
                );
            }
          } else {
            showAlert(
              "Sorry!!",
              "Summary can only be viewed of Processed payrolls.",
              cannotDeleteOrUpdate
            );
          }
        }
    }

    const processPayroll = (data) => {
        const rowData = data && data.rowData ? data.rowData : "";
        if (rowData) {
          if (!rowData.processed) {
              let payrunId = rowData.id;
              if (payrunId) {
                RouteManager.navigateToPage(
                  PAGE_ROUTES.PROCESS_PAYROLL,
                  `module=${TABLES.PAYROLL}&origin=${PAGE_ROUTES.PAYROLL_GRID}&id=${payrunId}&step=0&isContractor=false`
                );
              }
          } else {
            showAlert(
              "Sorry!!",
              "Selected Payroll has already been processed.",
              cannotDeleteOrUpdate
            );
          }
        }
    }

    const onRowEdit = (data, isFromRowOpen) => {
        const rowData = data && data.rowData ? data.rowData : '';
        if(!isFromRowOpen && rowData) {
            if(!rowData.processed) {
                const payrollId = data.rowData ? data.rowData.id : "";
                const { payruns, filterResponse } = payrollData;
                const selectedPayrun = payruns.filter(x => x._id === payrollId);
                if (selectedPayrun && selectedPayrun.length > 0) {
                    let dataToEdit = selectedPayrun[0];
                    let paySchedules = payscheduleList ? payscheduleList.schedules : [];
                    let usersList = users ? users.users : [];
                    let defaultValues = PayrollManager.getPayrollDefaultValues(dataToEdit, customFieldsData);
                    const { tenant } = TenantManager.getPeopleTenantData();
                    showPayrollPopup({
                      tableName: "people_add_payroll",
                      displayName: "Payrun",
                      recordId: payrollId,
                      defaultValues:defaultValues,
                        
                      isCustomForm: true,
                      inputData: {
                        paySchedules: paySchedules,
                        users: usersList,
                        payrollDispatch: dispatch,
                        tenantData: tenant,
                        locationList: locationData,
                        customFields: customFieldsData
                      },
                    });
                }
            } else {
                showAlert(
                    "Sorry!!",
                    "Processed payroll cannot be edited",
                    cannotDeleteOrUpdate
                )
            }
        } else if(isFromRowOpen && rowData) {
          if (rowData.processed) {
            viewDetailedView({rowData :rowData});
          } else {
            processPayroll({ rowData : rowData });
          }

        }
    };

    const onSearch = (searchTerm) => {
        const config = {
            ...PayrollService.apiConfig,
            Page: 0,
            SearchTerm: searchTerm
        };
        loadPayrolls(config);
    };
    const newColumnAdded = (data) => {
        const columns = payrolls.columnData;
        columns.push(data);
        setPayrolls({ ...payrolls, columnData: columns });
    };

    const onFilter = (updatedList, queries) => {
        PayrollService.conditionalPayrunsConfig = null;
        if(!Utility.isEmpty(queries.length)) {
            const conditions = [];
            queries.forEach((q) => {
                const { isLocationActive, locationSettings } = getLocationActiveStatus();
                const columnName = isLocationActive ? locationSettings?.locationLabel : "";
                let group = {
                    opr: q.condition
                };
                let isDateFilter = false;
                let index = customFieldsData?.customFields.findIndex(c => c.id === q.key);
                if (index != -1 && customFieldsData?.customFields[index].type === "date") {
                  isDateFilter = true;
                }
                if(columnName === q.key) {
                    group["colId"] = "location";
                    group["key"] = "location";
                } else {
                    group["colId"] = q.key;
                    group["key"] = "customField";
                }
              if (Array.isArray(q.value) && !Utility.isEmpty(q.value.length)) {
                group["value"] = q.value[0].toString();
              } else if (isDateFilter) {
                group["value"] = convertDateToJson(q.value);
              } else {
                group["value"] = q.value;
              }
                conditions.push(group);
            });
            const params = {
                conditions : conditions,
                isFilterEnabled : true
            };
            PayrollService.conditionalPayrunsConfig = params;
            setConditionFilter(params);
        }
        PayrollService.filterArray = queries;
        setFilterArray(queries);
        let config = {
            ...PayrollService.apiConfig,
            CurrentPage: 1,
          }
        loadPayrolls(config);
    };

    const onRowAdd = (newRow) => {
        // if (newRow) {
        //     let updatedRowData = [...contacts.rowData];
        //     updatedRowData.unshift(newRow);
        //     setContacts({
        //         ...contacts,
        //         rowData: updatedRowData,
        //         originalData: updatedRowData
        //     });
        // }
    };

    const onSegmentSelect = (segment, index) => {

        let payrunsList = payrollData.payruns || [];
        const { tenant } = TenantManager.getPeopleTenantData();
        const isCashfreeEnabled = tenant && tenant.isCashfreeEnabled ? tenant.isCashfreeEnabled : false;
        const functionConfig = getFunctionConfig();
        let config = {
          ...PayrollService.apiConfig,
          CurrentPage: 1,
        }
        if(segment.id === 1) {
            config = {
              ...config,
              SearchField:'EMPLOYEE_WITH_PROCESSED_STATUS',
            SearchString:'false'
            }
        } else if (segment.id === 2) {
          config = {
            ...config,
            SearchField:'EMPLOYEE_WITH_PROCESSED_STATUS',
            SearchString:'true'
          }
        } else {
          delete config['SearchField']
          delete config['SearchString']
        }
        loadPayrolls(config)
        setFilterInitialValue(segment.id);
    };

    const getRecentUpcomingPayroll = (payruns) => {
        let inputPayrolls = payruns.filter(x => !x.processed);
        const sortByDate = arr => {
            const sorter = (a, b) => {
                return new Date(b.processedAt).getTime() - new Date(a.processedAt).getTime();
            }
            arr.sort(sorter)
        }
        sortByDate(inputPayrolls);
        setRecentUpcoming(inputPayrolls);
        return inputPayrolls
    }

    const getProcessedPayroll = (payruns) => {
      let inputPayrolls = payruns.filter((x) => x.processed);
      const sortByDate = (arr) => {
        const sorter = (a, b) => {
          return (
            new Date(b.processedAt).getTime() -
            new Date(a.processedAt).getTime()
          );
        };
        arr.sort(sorter);
      };
      sortByDate(inputPayrolls);
      return inputPayrolls;
    };

    const navigateToProcessPayroll = (data, isFromGrid) => {
        let payrollId = "";
        if (!isFromGrid) {
            payrollId = recentUpcoming[0]._id;
        }
        RouteManager.navigateToPage(
            PAGE_ROUTES.PROCESS_PAYROLL,
            `module=${TABLES.PAYROLL}&origin=${PAGE_ROUTES.PAYROLL_GRID}&id=${payrollId}&step=0`,
        )
    }

    const onCreateNew = (row = {}) => {
        let paySchedules = payscheduleList ? payscheduleList.schedules : [];
        let usersList = users ? users.users : [];
        const { tenant } = TenantManager.getPeopleTenantData();
        showPayrollPopup({
          tableName: "people_add_payroll",
          displayName: "Payrun",
          recordId: row ? row.id : "",
          defaultValues: PayrollManager.getAddPayrunDefaultValues(customFieldsData),
          isCustomForm: true,
          inputData: {
            paySchedules: paySchedules,
            users: usersList,
            payrollDispatch: dispatch,
            tenantData: tenant,
            locationList: locationData,
            customFields: customFieldsData
          },
        });
    }

    const getFunctionConfig = () => {
      let config = {
        "editPayroll": onRowEdit,
        "deletePayroll": onDeletePayroll,
        "processPayroll": processPayroll,
        "viewPayroll": viewDetailedView,
        "repayParoll": onPayrollRepayment,
        "revertPayrun": onRevertFromSideMenu,
        "makePayment": onMakePayment,
        "downloadPTSFile": onPTSFileDownload
      };
      return config;
    }

    const onPayrollRepayment = (data) => {
      const rowData = data && data.rowData ? data.rowData : '';
        if(rowData) {
            if(rowData.processed) {
                const payrollId = data.rowData ? data.rowData.id : "";
                showLoader("Payment initialization in progress...");
                Table.retryPayment(payrollId).finally(removeLoader()).then(
                  (res) => {
                    if (res) {
                      showToast(
                        "Payment Initiated successfully",
                        TOAST_TYPE.SUCCESS
                      );
                      loadPayrolls({});
                    }
                  },
                  (err) => {
                    showToast("Something went wrong", TOAST_TYPE.FAILURE);
                  }
                );
                }
            }
    }
    const cannotExport = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      }
    ];
    const exportPayrun = (data) => {

      const queryParams = {
        format: 'XLSX',
        countryCode: TenantService.get(TENANT.COUNTRY_CODE),
        timezoneOffset: new Date().getTimezoneOffset() * -1,
        isContractor: false
      };
      const options = {
        endPointOptions: null,
        fileName: 'Payrun',
        fileType: supportedFileTypes['XLSX']
      }
      setExportButtonName('Exporting...')
      getExportDataFile(queryParams, data, options, 'EXPORT_PAYRUN')
        .then((res) => {
          setExportButtonName('Export Payrun')
          showToast('Payrun exported Successfully', TOAST_TYPE.SUCCESS);
          setReload(!reload);
        })
        .catch((error) => {
          setExportButtonName('Export Payroll')
          showToast('Internal server error', TOAST_TYPE.ERROR);
          setReload(!reload);
        });
    }
    const onRevertClick =(data)=>{
      if(data && data.length == 1) {
        showAlert(
          "Confirm",
          `Are you sure you want to revert the Payroll with Payroll Cost of ${data[0].totalCost} dated ${Utility.formatDate(data[0].payrollData.payDate, FORMAT.MMDDYYYY_2) }?`,
          [
            {title: "No", className: "bg-gray1 border-m"},
            {title: "Yes", className: "bg-app text-white ml-m", onClick: () => revert(data[0])}

          ]
        )
      }
    }

    const onRevertFromSideMenu = (data) => {
      if (data && data?.rowData) {
        showAlert(
          "Confirm",
          `Are you sure you want to revert the Payroll with Payroll Cost of ${
            data?.rowData?.totalCost
          } dated ${Utility.formatDate(
            data?.rowData?.payrollData.payDate,
            FORMAT.MMDDYYYY_2
          )}?`,
          [
            { title: "No", className: "bg-gray1 border-m" },
            {
              title: "Yes",
              className: "bg-app text-white ml-m",
              onClick: () => revert(data?.rowData),
            },
          ]
        );
      }
    };

    const onMakePayment = (data) => {
      if (data.rowData.payrollData) {
        let payrun = data.rowData.payrollData
        GiroService.MakePaymentValues = {
          payrunId: payrun._id,
          totalCost: payrun.netPay ? payrun.netPay : 0,
          firstPayDate: payrun.firstPayDate,
          backRout: PAGE_ROUTES.PAYROLL_GRID
        }
        RouteManager.navigateToPage(PAGE_ROUTES.GIRO_MAKE_PAYMENT + '/1');
      }
    }

    const revert=(row)=>{
      Table.revertPayroll(row.id).then(res=>{
        showToast('Payrun reverted Successfully', TOAST_TYPE.SUCCESS);
        loadPayrolls({});
      },error=>{
        showToast('Unable to revert selected payroll', TOAST_TYPE.ERROR);
      })
    }

    const onContextCancel = () => {
      setReload(!reload)
    }

    const getLocationActiveStatus = () => {
        let isLocationActive = false;
        const { additionalSettings } = tenantDetails || "";
        const locationSettings = additionalSettings
            ? additionalSettings?.["LOCATION"]
            : {};
        isLocationActive = locationSettings?.trackLocation || false;

        return {isLocationActive, locationSettings};
    }

    const updateEmployeeColumnConfig = (columnConfig) => {
        const { isLocationActive, locationSettings } = getLocationActiveStatus();
        const columnName = isLocationActive ? locationSettings?.locationLabel : "";
        const locationColumn = LOCATION_COLUMN_CONFIG;
        const locationList = locationData?locationData : []
        const locationOptions = locationList && locationList.map((x) => {
            return {
                id: x.id,
                name: x.label,
                ...x
            };
        });
        locationColumn["name"] = columnName;
        locationColumn["columnCode"] = columnName;
        locationColumn["key"] = columnName;
        locationColumn["id"] = columnName;
        locationColumn["options"] = locationOptions;
        const totalCostIndex = columnConfig.findIndex(c=> c.columnCode === COLUMN_CODE.PAYROLL.TOTAL_COST);
        totalCostIndex !== -1 ? columnConfig.splice(totalCostIndex,0,locationColumn) : columnConfig.push(locationColumn);
        return columnConfig;
    }

    const updateColumnConfigWithCustomField = (columnConfig) => {
        let fieldConfig  = customFieldsData?.customFields?.filter(field=>field.isActive) || [];
        fieldConfig?.forEach((c) => {
            let group = {
                name:c.name,
                columnCode:c.id,
                id:c.id,
                key:c.id,
                width:150,
                editable:false,
                uiVisible :true
            };
            group = getFieldConfigOnType(group,c);
            columnConfig.push(group);
        });
        return columnConfig;
    }

    const getFieldConfigOnType = (group, c) => {
        switch(c.type) {
            case "text":
                group['type'] = INPUT_TYPE.TEXT;
                break;
            case "number":
                group['type'] = INPUT_TYPE.NUMBER;
                break;
            case "multiselect":
                const options = c.possibleValues.map((p) => {
                    return{
                        id:p,
                        name:p
                    }
                });
                group['type'] = INPUT_TYPE.MULTI_SELECT;
                group['options'] = options;
                break;
            case "date":
                group['type'] = INPUT_TYPE.DATE;
                break;
            default:
                group['type'] = INPUT_TYPE.TEXT;
        }
        return group;
    }

    const onPTSFileDownload = (data) => {
        showLoader("Downloading fie... Plese wait")
        if (data?.rowData?.payrollData) {
            PayrollService.downloadPTSFile(data.rowData.payrollData._id).then((response) => {
                if (response) {
                    const fileName = `MASTER_TAX${moment().format("MM-DD-YYYY")}.txt`
                    showToast("Master tax file downloaded successfully",TOAST_TYPE.SUCCESS)
                    response = new Blob([response], {type : 'application/json'});
                    saveAs(response, fileName);
                }
                removeLoader();
            })
          }
    }

  const getApplicableToPopup = () => {
    let applicableToColumn = ``;
    applicableToColumn = 
      `${applicableToPopup?.employeeDetails?.length > 1 ? "Employees" : "Employee"}`
    return (
      <>
        <Popup className="" >
          <div className="row justify-content-between">
            <DKLabel className="fw-m fs-m" text={`Total ${applicableToColumn}: ${applicableToPopup.employeeDetails?.length}` } />
            <DKButton className="" icon={DKIcons.ic_close} title="" onClick={() => setApplicableToPopup(null)} />
          </div>
          <div className="">
            <ol>
              {applicableToPopup.employeeDetails.map(user => {
                return <li className="p-v-xs">{getEmployeeName(user)}</li>
              })}
            </ol>
          </div>
        </Popup>
      </>
    )
  }
  const getEmployeeName = (user) => {
    if (user) {
      return `${user?.firstName} ${user?.lastName}`
    } else {
      return ''
    }
  }
    const onColumnUpdate = (data) =>{
      // note this fun will use later
    }

    return (
      <>
      <ReadWatchComponent
                    title = "Need help getting started? Learn more about creating Payroll."
                    onRead = { () => window.open(
                      "https://www.deskera.com/care/add-new-payrun-deskera-hris/",
                      "_blank"
                    )}
                    onWatch = { AppManager.showComingSoonWarning}
                    export={PermissionUtils.hasAccess(MODULE.PAYRUN,ACTION.EXPORT) ? exportButtonName:null}
                    exportTitle='Manage your Payroll.'
                    exportTitleInfo=""
                    onExportClick={()=>{
                      if(selectedRow.length == 0) {
                        showAlert("Info", "Please select payrun(s) to export.", cannotExport)
                      } else {
                        let payrollIdsToExport = []
                        selectedRow.forEach(row=>{
                        payrollIdsToExport.push(row.id)
                        })
                        let payload = {
                          ids: payrollIdsToExport,
                        };
                        exportPayrun(payload);
                      }

                    }}
                />
        {recentUpcoming && recentUpcoming.length ? (
          <div className="parent-width">
            <div className="bg-white p-l mt-l border-radius-m border-m">
              <div className="row mb-xl align-items-start">
                <div className="column">
                  <div className="row">
                    <span className="text-gray">Upcoming Payroll</span>
                    <span className="ml-s fw-m">
                      {recentUpcoming[0] && recentUpcoming[0]["paySchedule"]
                        ? recentUpcoming[0]["paySchedule"]["name"]
                        : ""}
                    </span>
                  </div>
                  <div className="text-gray mt-s fs-m">
                    {recentUpcoming[0] ? Utility.formatDate(recentUpcoming[0]["payDate"], FORMAT.MMDDYYYY_2) : ""}
                  </div>
                </div>
                <div
                  className="ms-auto"
                  style={{
                    marginLeft: "auto",
                  }}
                >
                  {PermissionUtils.hasAccess(MODULE.PAYRUN,ACTION.SUBMIT) && <DKButton
                    className="bg-app text-white"
                    style={{
                      "justify-content": "center",
                    }}
                    title="Process Payroll"
                    onClick={(data) => navigateToProcessPayroll(data, false)}
                  />}
                </div>
              </div>
              <div className="row row-responsive">
                <div className="column mr-xxl mt-m pr-xl">
                  <span className="text-gray">Payroll Cost</span>
                  <span className="fw-m fs-xl">
                    <FormatCurrency className="fw-m fs-xl" amount={recentUpcoming[0].totalEarnings} />
                  </span>
                </div>
                <div className="column mr-xxl mt-m pr-xl">
                  <span className="text-gray">Total Earnings</span>
                  <span className="fw-m fs-xl">
                    <FormatCurrency className="fw-m fs-xl" amount={recentUpcoming[0].totalEarnings} />
                  </span>
                </div>
                <div className="column mr-xxl mt-m pr-xl">
                  <span className="text-gray">Total Deductions</span>
                  <span className="fw-m fs-xl">
                    <FormatCurrency className="fw-m fs-xl" amount={recentUpcoming[0].totalCost - recentUpcoming[0].totalEarnings} />
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <div className="column parent-width flex-1">
          {true && (
            <SegmentListContainer
              data={payrollFilters}
              selectedId={initialValue}
              onChange={onSegmentSelect}
              // onClickNew={this.showAddSegmentPopup}
              maxWidth={React.createRef().current?.innerWidth}
              isAddEnabled={false}
            />
          )}
          <div className="column mt-l parent-width mb-s position-relative flex-1 ">
            <DataGridHolderPayroll
              tableName={TABLES.PAYROLL}
              displayTableName={TABLE_DISPLAY_NAME[TABLES.PAYROLL]}
              allowRowEdit={PermissionUtils.hasAccess(MODULE.PAYRUN,[ACTION.VIEW])}
              allowColumnEdit={false}
              allowRowAdd={true}
              allowColumnAdd={false}
              allowColumnDelete={true}
              allowColumnShift={false}
              allowSearch={false}
              allowFilter={isFilterEnabled}
              onRowDelete={(data)=>{
                onDeletePayroll(data)
              }}
              onRowEdit={(data, isFromRowOpen) => {
                onRowEdit(data, isFromRowOpen);
              }}
              onCancelContext={() => {
                onContextCancel();
              }}
              onRowDetailedView={viewDetailedView}
              onProcessPayroll={processPayroll}
              refresh={refresh}
              addButtonConfig={[{
                title: "+ Add Payrun",
                className: "bg-app text-white ml-s",
                onClick: () => onCreateNew(),
              }]}
              allowDataExport={true}
              gridData={payrolls}
              onSearch={onSearch}
              onColumnAdd={newColumnAdded}
              onFilter={onFilter}
              filter={filterArray}
              onRowAdd={onRowAdd}
              onSelection={(data)=>{
                selectedRow = data
              }}
              onPaginationClick={(requestedPageNumber) => {
                const config = {
                  ...PayrollService.apiConfig,
                  CurrentPage: requestedPageNumber, // Books backend pagination offset is 0, so subtract 1
                  Limit: 20,
                };
                loadPayrolls(config);
              }}
              currentPage={currentPage}
              totalPageCount={totalPageCount}
              isActionEnabled={isActionEnabled}
              contextMenu={true}
              showContextEdit={false}
              isMenuVisible={true}
              onRevertClick={onRevertClick}
              latestProcessedPayrollId={latestProcessedPayrollId}
              onColumnUpdate={onColumnUpdate}
              onColumnShift={(data)=> setReload(!reload)}
              module={MODULE.PAYRUN}
            />
          </div>
        </div>
        {applicableToPopup && getApplicableToPopup()}
      </>
    );
}

export default PayrollGrid;